import algoliasearch from 'algoliasearch';
import autocomplete from 'autocomplete.js';
import places from 'places.js';

let searchPagePath = './search.html';
const searchConfig = {
  appId: '06TCVB0ZTH',
  apiKey: '6e613c5b74f59097b34d4a52026d19ee',
  //indexName: 'dev_gourmet_society',
  indexName: 'prod_gourmet_society_web',
};
const placesConfig = {
  appId: 'plL8OWBLPX6O',
  apiKey: 'c7f110dd8044c333a3d332e3554bf375',
};
let selectedPlace;
let cachedCurrentLocation;
let fetchedHits;
let fetchedLocations;
let goToProductFn;

const SEARCH_BOXES_OPENED = 'search-boxes-opened';
let navSelector;

let autocompleteInstance;
let placesInstance;
let placesSearch;

window.autocompleteHeader = {
  setup: ({
    selector: {
      triggerContainer,
      searchBoxesContainer,
      closeButton,
      nav = 'nav.navbar',
    },
    searchPage = './search.html',
    popupOnlyOnFocus = false,
    shouldClearRefine = false,
    goToProduct = defaultGoToProduct,
  }) => {
    navSelector = nav;
    searchPagePath = searchPage;
    goToProductFn = goToProduct;
    renderTrigger(triggerContainer);
    const triggerSelector = `${triggerContainer} .autocomplete-trigger-button.desktop-only`;
    setupTriggers(triggerSelector);
    setupCloseButton(closeButton);
    setupSearchBoxes({
      searchBoxesContainer,
      popupOnlyOnFocus,
      shouldClearRefine,
    });
    applyParamsFromURL(searchBoxesContainer);
    getCurrentPosition()
    .then(({ lat, lng }) => applyDevLocParamURI());
  },
  openSearchBoxes,
  closeSearchBoxes,
  selectFirstItem,
};

function applyParamsFromURL(searchBoxesContainer) {
  const params = new URLSearchParams(location.search);
  const cuisine = params.get('refinementList[cuisine][0]');
  const query = params.get('query');
  autocompleteInstance.setVal(cuisine || query || '');
  const place = params.get('place');
  placesInstance.setVal(place || '');

  const container = document.querySelector(searchBoxesContainer);
  container.querySelector(
    '.ais-icon-clear'
  ).style.display = autocompleteInstance.getVal() ? 'block' : 'none';
  container.querySelector(
    '.ap-icon-clear'
  ).style.display = placesInstance.getVal() ? 'block' : 'none';
}

function renderTrigger(triggerContainerSelector) {
  const container = document.querySelector(triggerContainerSelector);
  container.classList.add('autocomplete-trigger-container');
  container.innerHTML = `
    <button type="button" class="autocomplete-trigger-button desktop-only">
      <i class="fa fa-2x fa-search"></i>
    </button>
    <a href="#" class="nav-link" role="button" ></a>
  `;
}

function setupTriggers(triggerSelector) {
  document.querySelector(triggerSelector).addEventListener('click', () => {
    openSearchBoxes();
  });
}

function setupCloseButton(closeButtonSelector) {
  const closeButton =
    closeButtonSelector && document.querySelector(closeButtonSelector);
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      closeSearchBoxes();
    });
  }
}

function openSearchBoxes() {
  document.querySelector(navSelector).classList.add(SEARCH_BOXES_OPENED);
  document.body.classList.remove('search-boxes-closed');
}

function closeSearchBoxes() {
  document.querySelector(navSelector).classList.remove(SEARCH_BOXES_OPENED);
  document.body.classList.add('search-boxes-closed');
}

function blurSearchBoxes() {
  var tmp = document.createElement("input");
  document.body.appendChild(tmp);
  tmp.focus();
  document.body.removeChild(tmp);
}

function setupSearchBoxes({
  searchBoxesContainer,
  popupOnlyOnFocus,
  shouldClearRefine,
}) {
  const container = renderSearchBoxesContainer(searchBoxesContainer);
  setupAutocomplete({ shouldClearRefine });
  setupPlaces({ container, shouldClearRefine });
  setupPopupOnlyOnFocus({ container, popupOnlyOnFocus });
  return container;
}

function setupPopupOnlyOnFocus({ container, popupOnlyOnFocus }) {
  const popupElem = container.querySelector('.explore-popup');
  const show = () => {
    popupElem.style.display = 'block';
    document.body.classList.add('search-popup-opened');
  };
  const hide = () => {
    const delay = popupOnlyOnFocus ? 200 : 0;
    setTimeout(() => {
      if (!focused) {
        // It doesn't hide when it's focused after delay.
        popupElem.style.display = 'none';
        document.body.classList.remove('search-popup-opened');
      }
    }, delay);
    /*
      Some delay is required here.

      With `popupOnlyOnFocus` being true,
      if user clicks "Explore near me",
      it takes focus out of search box which triggers a `blur` event
      and it leads to hiding `.explore-popup`.

      It happens right before a click happens on "Explore near me" <a> element,
      which means the click actually never happened.

      So we have some delay here to prevent this situation.
    */
  };
  if (popupOnlyOnFocus === false) {
    show();
    return;
  }

  hide();
  let focused = false;
  const update = value => {
    focused = value;
    focused ? show() : hide();
  };
  ['.autocomplete-popup-searchbox', '.autocomplete-popup-location'].forEach(
    selector => {
      const elem = document.querySelector(selector);
      elem.addEventListener('focus', () => update(true));
      elem.addEventListener('blur', () => update(false));
    }
  );
}

function renderSearchBoxesContainer(searchBoxesContainer) {
  const container = document.querySelector(searchBoxesContainer);
  container.className = 'autocomplete-popup';
  container.innerHTML = `
    <div class="input-wrapper">
      <a href="#" class="alg-exit-button-mobile">exit</a>
      <input type="search" class="autocomplete-popup-searchbox" placeholder="e.g. restaurant name, cuisine, cinema" autocomplete="__gs_query__" />
      <input type="search" class="autocomplete-popup-location" placeholder="e.g. town, city, street" oninput="this.value=this.value.replace(/^\\s+/,'')" />
      <button type="button" class="current-location-mobile-btn">Get my current location</button>
    </div>
    <div class="explore-popup">
      <ul>
        <li>
          <a href="${searchPagePath}" class="icon icon-location js-nearme">
            <span class="primary">Explore near me</span>
          </a>
        </li>
        <li>
          <a href="${searchPagePath}?type=restaurant" class="icon icon-restaurant">
            <span class="title">Explore Restaurants</span>
            <span class="subtitle">25% off the total bill</span>
          </a>
        </li>
        <li>
          <a href="${searchPagePath}?type=cinema" class="icon icon-cinema">
            <span class="title">Explore Cinema</span>
            <span class="subtitle">Up to 40% off</span>
          </a>
        </li>
      </ul>
    </div>
  `;
  const mobileCloseButton = container.querySelector('.alg-exit-button-mobile');

  mobileCloseButton.addEventListener('click', e => {
    e.preventDefault();
    closeSearchBoxes();
  });

  const nearmeButton = container.querySelector('.js-nearme');

  nearmeButton.addEventListener('click', e => {
    e.preventDefault();
    getAndSetCurrentPosition();
  });

  return container;
}

function setupAutocomplete({ shouldClearRefine }) {
  const client = algoliasearch(searchConfig.appId, searchConfig.apiKey);
  const search = autocomplete(
    '.autocomplete-popup-searchbox',
    { autoselect: true, hint: false },
    [
      {
        cache: false,
        source: function(query, callback) {
          const index = client.initIndex(searchConfig.indexName);

          searchForFacetValues(index, query)
            .then(facetHits =>
              searchForHits(index, query).then(answer => ({
                facetHits,
                answer,
              }))
            )
            .then(({ facetHits, answer }) =>
              callback(
                combineHits({
                  facetHits,
                  hits: answer.hits,
                  query,
                  nbHits: answer.nbHits,
                }),
                answer
              )
            );
        },
        displayKey: 'name',
        templates: {
          suggestion: function(suggestion) {
            if (suggestion.isFacetHit) {
              return `
              <div class="suggestion-cuisine">
                <div class="flex">
                  <span class="icon icon-restaurant"></span>
                  <div class="texts">
                    <p class="query">${suggestion.value}</p>
                    <p class="desc">${suggestion.count} results</p>
                  </div>
                </div>
                <span class="view-all">View all results</span>
              </div>
              `;
            } else if (suggestion.isInjected) {
              return `
              <div class="suggestion-cuisine">
                <div class="flex">
                  <span class="icon icon-query"></span>
                  <div class="texts">
                    <p class="query">${suggestion.value}</p>
                    <p class="desc">${suggestion.count} results</p>
                  </div>
                </div>
                <span class="view-all">View all results</span>
              </div>
              `;
            } else {

              const address = [
                ['building', 'street']
                  .map(x =>
                    suggestion &&
                    suggestion.contact &&
                    suggestion.contact.address
                      ? suggestion.contact.address[x]
                      : undefined
                  )
                  .filter(Boolean)
                  .join(' '),
                suggestion.contact &&
                  suggestion.contact.address &&
                  suggestion.contact.address.town,
                suggestion.contact &&
                  suggestion.contact.address &&
                  suggestion.contact.address.postcode,
              ]
                .filter(Boolean)
                .join(', ');

              if (suggestion.type){
                  if((window.user_type === 'default' || window.user_type === 'gourmetsociety_b2b')
                      && suggestion.type === 'cinema'
                      && suggestion.venue === 'Cineworld') {
                          return '';
                  } else {
                  return `
                    ${suggestion.isFirstHit ? '<hr />' : ''}
                    <div class="suggestion-wrapper">
                      <span class="icon ${
                        suggestion.type === 'cinema'
                          ? 'icon-cinema'
                          : 'icon-restaurant'
                      }"></span>
                      <div class="texts">
                        <p class="name">${suggestion.name}</p>
                        <p class="address">${address}</p>
                      </div>
                      <span class="right-arrow"></span>
                    </div>
                  `;
                      }
              }
            }
          },
        },
      },
    ]
  ).on('autocomplete:selected', function(event, suggestion) {
    onHitSelected(suggestion);
  });
  autocompleteInstance = search.autocomplete;

  const autocompleteContainer = document.querySelector(
    '.autocomplete-popup-searchbox'
  ).parentNode;
  const clear = document.createElement('button');
  clear.setAttribute('type', 'button');
  clear.setAttribute('aria-label', 'clear');
  clear.classList.add('ais-icon-clear');
  autocompleteContainer.appendChild(clear);
  clear.style.display = 'none';
  clear.addEventListener('click', () => {
    autocompleteInstance.setVal('');
    clear.style.display = 'none';
    if (shouldClearRefine) {
      goToResult({ clearCuisine: true, clearQuery: true });
    }
  });
  document
    .querySelector('.autocomplete-popup-searchbox')
    .addEventListener('input', () => {
      const query = autocompleteInstance.getVal();
      clear.style.display = query === '' ? 'none' : '';
    });
}

function onHitSelected(suggestion) {
  // console.log(suggestion);
  // console.log(window.user_type);
  // console.log(window.membership_status);
  // cinema item clicked in autosuggest, user not logged in
  if (suggestion.type == "cinema" && window.user_type != "gourmetsociety_plus" && window.user_type != "gourmetsociety_b2b" && window.user_type != "gourmetsociety_eb") {
    //console.log('login required');
    var event = new CustomEvent("showModalExt",{
      detail: {
        modal:  {
          type: "user_login_required",
        }
      }
    });
    window.dispatchEvent(event);
    blurSearchBoxes();
  }

  // cinema item clicked in autosuggest, user logged in but invalid
  else if (suggestion.type == "cinema" && (window.user_type == "gourmetsociety_plus" || window.user_type == "gourmetsociety_b2b" || window.user_type == "gourmetsociety_eb") && window.membership_status != "valid") {
    //console.log('valid membership required');
    var event = new CustomEvent("showModalExt",{
      detail: {
        modal:  {
          type: "valid_membership_required",
        }
      }
    });
    window.dispatchEvent(event);
    blurSearchBoxes();
  }

  // any other clicks in autosuggest
  else {
    if (suggestion.isInjected || suggestion.isFacetHit) {
      goToResult({
        query: suggestion.value,
        clearCuisine: true,
      });
    }
    /*
    else if (suggestion.isFacetHit) {
      goToResult({
        cuisine: suggestion.value,
        clearQuery: true,
      });
    }
    */
    else {
      trackClick(suggestion);
      goToProductFn(suggestion);
    }

  }

}

function getCurrentPosition() {
  return new Promise((res, rej) => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        const lat = coords.latitude.toFixed(6);
        const lng = coords.longitude.toFixed(6);
        cachedCurrentLocation = { lat, lng };
        window.localStorage.setItem('algolia_search_request_location', cachedCurrentLocation.lat+',' +cachedCurrentLocation.lng);
        res({ lat, lng });
      },
      err => {
        if (cachedCurrentLocation) {
          res(cachedCurrentLocation);
        }
        rej(err);
      },
      cachedCurrentLocation ? { timeout: 2000 } : undefined
    );
    } else {
      window.localStorage.removeItem('algolia_search_request_location');
    }
  });
}

const getAndSetCurrentPosition = () =>
  getCurrentPosition()
    .then(({ lat, lng }) => placesSearch.reverse(`${lat},${lng}`))
    .then((hits = []) => {
      const hit = hits[0];
      if (!hit) {
        return;
      }
      placesInstance.setVal(hit.name);
      // document.querySelector('.autocomplete-popup-location').value = hit.name;
      setLocation({
        latlng: hit.latlng,
        name: hit.name,
      });
    })
    .catch(e => {
      console.warn('geolocation denied', e);
      goToResult({
        nearme: 'true',
      });
    });

function setupPlaces({ container, shouldClearRefine }) {
  container
    .querySelector('.autocomplete-popup-location')
    .addEventListener('blur', () => {
      placesInstance.close();
      // It's supposed to be closed on blur,
      // but somehow it's not working.
      // So this is a bad patch (hopefully) just for now.
    });
  const search = places({
    appId: placesConfig.appId,
    apiKey: placesConfig.apiKey,
    container: '.autocomplete-popup-location',
    useDeviceLocation: false,
    autocompleteOptions:{
      minLength:3
    }
  })
    .configure({
      hitsPerPage: 10,
      countries: ['GB', 'IE'],
    })
    .on('suggestions', ({ suggestions }) => {
      fetchedLocations = suggestions;
    })
    .on('change', ({ suggestion }) => {
      setLocation({ latlng: suggestion.latlng, name: suggestion.value });
    })
    .on('clear', () => {
      selectedPlace = null;
      if (shouldClearRefine) {
        goToResult({ clearPlace: true });
      }
    });
  placesInstance = search.autocomplete.autocomplete;
  placesSearch = search;

  const currentLocationButton = document.createElement('button');
  currentLocationButton.setAttribute('type', 'button');
  currentLocationButton.setAttribute('aria-label', 'Get current location');
  currentLocationButton.className = 'current-location-btn';
  currentLocationButton.addEventListener('click', getAndSetCurrentPosition);
  document.querySelector('.algolia-places').appendChild(currentLocationButton);

  document
    .querySelector('.current-location-mobile-btn')
    .addEventListener('click', getAndSetCurrentPosition);
}

function selectFirstItem() {
  const searchboxValue = document.querySelector('.autocomplete-popup-searchbox')
    .value;
  const locationValue = document.querySelector('.autocomplete-popup-location')
    .value.trim();

  if (locationValue && locationValue.length > 2 && fetchedLocations && fetchedLocations[0]) {
    const { latlng, value: name } = fetchedLocations[0];
    selectedPlace = { latlng, name };
  }

  if (searchboxValue && fetchedHits && fetchedHits[0]) {
    onHitSelected(fetchedHits[0]);
    return;
  }

  goToResult();
}

function setLocation({ latlng, name }) {
  selectedPlace = { latlng, name };
  goToResult({ clearNearMe: true });
}

function searchForFacetValues(index, query) {
  return index
    .searchForFacetValues({
      facetName: 'cuisine',
      facetQuery: query,
    })
    .then(({ facetHits = [] } = {}) => {
      return facetHits.map(hit => ({
        isFacetHit: true,
        ...hit,
      }));
    });
}

function searchForHits(index, query) {
  return index
    .search(query, {
      hitsPerPage: 10,
      clickAnalytics: true,
      analyticsTags: ['web-autocomplete'],
      aroundLatLng: selectedPlace
        ? `${['lat', 'lng'].map(key => selectedPlace.latlng[key]).join(', ')}`
        : undefined,
    })
    .then(answer => ({
      ...answer,
      hits: answer.hits.map(item => {
        item._queryID = answer.queryID;
        return item;
      }),
    }))
    .catch(() => []);
}

function combineHits({ facetHits, hits, query, nbHits }) {
  const querySuggestion =
    facetHits.length === 0
      ? [
          {
            isInjected: true,
            count: nbHits,
            value: query,
          },
        ]
      : [];

  const [firstHit, ...restHits] = hits.map((hit, index) => ({
    ...hit,
    __position: index,
  }));

  return [
    ...facetHits,
    ...querySuggestion,
    {
      isFirstHit: true,
      ...firstHit,
    },
    ...restHits,
  ];
}

function goToResult({
  cuisine,
  query,
  nearme,
  clearQuery = false,
  clearCuisine = false,
  clearPlace = false,
  clearNearMe = false,
} = {}) {
  const params = new URLSearchParams(location.search);
  const cuisineRefinement = {
    'refinementList[cuisine][0]':
      cuisine || params.get('refinementList[cuisine][0]'),
  };
  const { name, latlng } = getSelectedPlace();
  const coords =
    name && latlng
      ? {
          latlng: latlng,
          place: name,
        }
      : {};
  console.log({
    "nearme || (!clearNearMe && params.get('nearme') === 'true')":
      nearme || (!clearNearMe && params.get('nearme') === 'true'),
    nearme,
    clearNearMe,
    params: params.get('nearme'),
  });
  const nearMe =
    nearme || (!clearNearMe && params.get('nearme') === 'true')
      ? {
          nearme: true,
          place: 'Near Me',
        }
      : {};
  const place = {
    ...coords,
    ...nearMe,
  };
  const queryString = getQueryString({
    ...(clearCuisine ? {} : cuisineRefinement),
    ...(clearPlace ? {} : place),
    ...(clearQuery ? {} : { query: query || params.get('query') }),
  });
  if (location.search !== queryString) {
    location.href = `${searchPagePath}?${queryString}`;
  }
}

function trackClick({ _queryID, objectID, __position }) {
  window.aa('clickedObjectIDsAfterSearch', {
    eventName: 'Product Clicked',
    index: searchConfig.indexName,
    queryID: _queryID,
    objectIDs: [objectID],
    positions: [__position],
  });
}

/**
 * @param {{link: string}}
 */
function defaultGoToProduct({ link }) {
  if (link) {
    let url = `https://www.gourmetsociety.co.uk${link}`;
    if (link.slice(0, 4) === 'http') {
      url = link;
    }
    location.href = url;
  }
}

function getSelectedPlace() {
  if (selectedPlace) {
    const { name, latlng } = selectedPlace;
    return {
      name,
      latlng: `${latlng.lat},${latlng.lng}`,
    };
  }
  const params = new URLSearchParams(location.search);
  const name = params.get('place');
  const latlng = params.get('latlng');
  if (latlng && name) {
    return {
      name,
      latlng,
    };
  }

  return {};
}

function getQueryString(params) {
  return Object.keys(params)
    .reduce((acc, key) => {
      const val = params[key];
      if (val) {
        acc.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
      }
      return acc;
    }, [])
    .join('&');
}

function applyDevLocParamURI(lat, lng){
  var parser = new URL(window.location.href);
  if(!parser.searchParams.has('latlng') && !parser.searchParams.has('nearme')){
    parser.searchParams.set('latlng', window.localStorage.getItem('algolia_search_request_location'));
    window.location = parser.href;
  }
}
